module.exports = __webpack_public_path__ + "static/media/cf_logo.0fcd205b.png";